/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Architect_Detail9Inputs */

const en_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest, service worker, storage, and message-passing design.`)
};

const ar_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم Manifest وService Worker والتخزين وتمرير الرسائل.`)
};

const bn_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ম্যানিফেস্ট, সার্ভিস ওয়ার্কার, স্টোরেজ ও মেসেজ-পাসিং ডিজাইন।`)
};

const de_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest-, Service-Worker-, Speicher- und Nachrichtenübermittlungsdesign.`)
};

const es_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño de manifiesto, trabajador de servicio, almacenamiento y paso de mensajes.`)
};

const fr_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception de manifeste, de service worker, de stockage et de transmission de messages.`)
};

const pt_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto, service worker, armazenamento e design de passagem de mensagens.`)
};

const zh_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest、service worker、存储和消息传递设计。`)
};

const tr_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest, service worker, depolama ve mesaj iletme tasarımı.`)
};

const ru_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проектирование манифеста, сервис-воркера, стораджа и передачи сообщений.`)
};

const pl_svc_browser_extensions_architect_detail9 = /** @type {(inputs: Svc_Browser_Extensions_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt manifestu, service workera, storage'u i przekazywania wiadomości.`)
};

/**
* | output |
* | --- |
* | "Manifest, service worker, storage, and message-passing design." |
*
* @param {Svc_Browser_Extensions_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_architect_detail9 = /** @type {((inputs?: Svc_Browser_Extensions_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "de") return de_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "es") return es_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_architect_detail9(inputs)
	return en_svc_browser_extensions_architect_detail9(inputs)
});
export { svc_browser_extensions_architect_detail9 as "svc_browser-extensions_ARCHITECT_detail" }